// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "em{--tw-bg-opacity:1!important;background-color:#fef3c7!important}@supports (color:rgb(0 0 0/0)) and (top:var(--f )){em{background-color:rgb(254 243 199/var(--tw-bg-opacity))!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
